import React from "react";
import CrmSectionPage from "./CrmSectionPage";

export default function Loyalty() {
  return <CrmSectionPage sectionKey="loyalty" />;
}
